import { BoxProps, Box } from "@chakra-ui/react"
import React, { ReactNode } from "react"
import { useLocation, matchPath } from "react-router-dom"
import { useWindowSize } from "../../hooks/useWindowSize"
import { Menu } from "../Menu"

declare module "react" {
  interface CSSProperties {
    [key: `--${string}`]: string | number
  }
}

type LayoutProps = { children: ReactNode }
export const Layout = ({ children }: LayoutProps) => {
  const windowSize = useWindowSize()

  const location = useLocation()
  const isProductRoute =
    matchPath({ path: "/products", end: false }, location.pathname) !== null

  const stickyStyles: BoxProps = {
    position: "sticky",
    style: {
      "--height": `calc(${windowSize[1]}px - var(--space-4) - 0.8rem)`,
      height: `var(--height)`,
      top: `calc(-1 * var(--height) + 1.75rem)`,
    },
    clipPath: "inset(0 0 0 0)",
  }
  return (
    <Box
      id="content-root"
      zIndex={10}
      {...(isProductRoute ? stickyStyles : {})}
    >
      {children}
      <Menu />
    </Box>
  )
}
